import React from 'react';
import { FooterLegalContainer, FooterLegalStack } from './FooterLegal.styles';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import MightyLogo from 'src/app/icons/Custom/Logos/Mighty/Mighty';
import Typography from 'src/app/atoms/Typography/Typography';
import Youtube from 'src/app/icons/Monospaced/SocialIcons/Youtube';
import LinkedIn from 'src/app/icons/Monospaced/SocialIcons/LinkedIn';
import Spotify from 'src/app/icons/Monospaced/SocialIcons/Spotify';
import Instagram from 'src/app/icons/Monospaced/SocialIcons/Instagram';
import Twitter from 'src/app/icons/Monospaced/SocialIcons/Twitter';
import Facebook from 'src/app/icons/Monospaced/SocialIcons/Facebook';
import Clickable from 'src/app/atoms/Clickable/Clickable';

const FooterLegal = (): JSX.Element => {
  const renderCopyright = (justify: 'flex-start' | 'space-between') => (
    <Stack
      align='center'
      direction='row'
      gap='spacing-4xl'
      justify={justify}
    >
      <MightyLogo color='var(--bg-primary)' />
      <Typography
        type='paragraph'
        color='text-primary-on-brand'
        size='sm'
      >
        © 2025 Mighty Networks. All rights reserved.
      </Typography>
    </Stack>
  );

  const renderSocialLinks = () => (
    <Stack
      direction='row'
      gap='spacing-4xl'
      align='center'
      justify='center'
    >
      <Clickable href='https://www.youtube.com/channel/UC0kOOsZ55RofRas1uPIEZmg'>
        <Youtube color='var(--bg-brand-primary)' />
      </Clickable>
      <Clickable href='https://www.instagram.com/mightynetworks/'>
        <Instagram color='var(--bg-brand-primary)' />
      </Clickable>
      <Clickable href='https://www.facebook.com/mightynetworks/'>
        <Facebook color='var(--bg-brand-primary)' />
      </Clickable>
      <Clickable href='https://twitter.com/mightynetworks'>
        <Twitter color='var(--bg-brand-primary)' />
      </Clickable>
      <Clickable href='https://www.linkedin.com/company/mightynetworks/'>
        <LinkedIn color='var(--bg-brand-primary)' />
      </Clickable>
      <Clickable href='https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2'>
        <Spotify color='var(--bg-brand-primary)' />
      </Clickable>
    </Stack>
  );

  return (
    <FooterLegalContainer
      direction='column'
      align='stretch'
      maxWidth='width-3xl'
      maxWidthLg='width-md'
      padding={['spacing-none', 'spacing-4xl']}
      margin={['spacing-none', 'spacing-auto']}
    >
      <FooterLegalStack
        hideOn='lg'
        direction='row'
        justify='space-between'
        padding={['spacing-4xl', 'spacing-none', 'spacing-none', 'spacing-none']}
        border='1px 0px 0px 0px solid var(--border-brand-alt)'
      >
        {renderCopyright('flex-start')}
        {renderSocialLinks()}
      </FooterLegalStack>
      <FooterLegalStack
        showOn='lg'
        gap='spacing-4xl'
        direction='column'
        justify='flex-start'
        padding={['spacing-4xl', 'spacing-none', 'spacing-none', 'spacing-none']}
        border='1px 0px 0px 0px solid var(--border-brand-alt)'
      >
        {renderSocialLinks()}
        {renderCopyright('space-between')}
      </FooterLegalStack>
    </FooterLegalContainer>
  );
};

export default FooterLegal;
